import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import { AdminRoute } from "@/components/auth/AdminRoute";
import AdminInternationalBrands from "@/pages/admin/AdminInternationalBrands";

export const Route = createFileRoute("/admin/internacional/lojas")({
  head: () => seoHead({
    title: "Administração | Shopping do Bem",
    description: "Área administrativa do Shopping do Bem.",
    noindex: true,
  }),
  component: () => (
    <AdminRoute>
      <AdminInternationalBrands />
    </AdminRoute>
  ),
});
